import React from "react";

import ColumnSorter from "./ColumnSorter";
const TabularListing = (props) => {
  return (<>
      <div className="tabular-listing">
        <div className="tabular-listing-inner table-responsive">
          <table className="table table-bordered">
            <thead className="bg-active">
              <tr>
                {props.headers.map((header, inx) => {
                  return (
                    <th key={`th${inx}`} style={{ minWidth: "50px" }}>
                      <span className="mx-2">{header.label}</span>{" "}
                      {!header.disableSort && (
                        <span className="ms-3">
                          <ColumnSorter
                            sort_by={props.sort_by}
                            header={header}
                            sort_order={props.sort_order}
                            onSortClick={props.onSortClick}
                          />
                        </span>
                      )}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {props.rows &&
                props.rows.map((row) => {
                  return (
                    <tr key={row[props.identifier]}>
                      {props.headers.map((header, inx) => {
                        if (header.value) {
                          return (
                            <td key={`${row[props.identifier]}-${inx}`}>
                              {header.value(row)}
                            </td>
                          );
                        } else {
                          return (
                            <td key={`${row[props.identifier]}-${inx}`}>
                              {row[header.attr]}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
  </>
  );
};

export default TabularListing;
